import React, { Fragment } from 'react';
import HeaderTopbar from '../../components/HeaderTopbar/HeaderTopbar';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import PricingSection from '../../components/PricingSection/PricingSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/kihi logo.png'
import About3 from '../../components/about3/about3';
import WhyChooseUs from '../../components/WhyChoose/WhyChoose';


const AboutPage = () => {
    return (
        <Fragment>
            {/* <HeaderTopbar /> */}
            <Navbar hclass={'wpo-site-header wpo-site-header-s3'} Logo={Logo} />
            <PageTitle pageTitle={'About Us'} pagesub={'About'} />
            <About3 hclass={'wpo-about-section-s3 section-padding'} />
            <WhyChooseUs />
            {/* <ServiceSection hclass={"wpo-service-section section-padding"} />
            <PricingSection pClass={"wpo-pricing-section section-padding pt-0"} />
            <BlogSection tClass={'wpo-blog-section section-padding'} /> */}
            <Footer />
            <Scrollbar />

        </Fragment>
    )
};
export default AboutPage;
